import React from 'react'
import { createUseStyles } from 'react-jss'
import obj2Arr from '../../utils/obj2Arr'
import AccordionItem from './atoms/AccordionItem'

const useStyles = createUseStyles(theme => ({
  accCntainer: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1200px',
    '@media (max-width: 700px)': {
      padding: '25px 0',
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '100px',
      '@media (max-width: 1200px)': {
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
      '@media (max-width: 700px)': {
        gridTemplateColumns: '1fr',
        gridGap: '0',
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
    },
  },
  accTitle: {
    fontSize: '26px',
    lineHeight: '32px',
    letterSpacing: '-1%',
    marginBottom: '30px',
    marginTop: '10px',
    fontWeight: 700,
  },
  accDetails: {
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.02em',
    },
  },
}))

const Accordion = props => {
  const { title, body, accordions, onlyItems, backgroundcoloron, noPaddingTop } = props
  const classes = useStyles()

  const objArr = obj2Arr(accordions)

  if (onlyItems || title === '') {
    return (
      <div>
        {objArr &&
          objArr.map(({ title, body, state }) => (
            <AccordionItem onlyItems key={title} title={title} body={body} state={state} />
          ))}
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: backgroundcoloron == '1' ? '#F0F8FF' : '' }}>
      <div className={classes.accCntainer} style={noPaddingTop == '1' ? { paddingTop: 0 } : {}}>
        <div style={noPaddingTop == '1' ? { paddingTop: 0 } : {}}>
          <div>
            <div className={classes.accTitle}>{title}</div>
            <div className={classes.accDetails} dangerouslySetInnerHTML={{ __html: body }} />
          </div>
          <div>
            <div style={{ backgroundColor: '#fff', borderRadius: '30px', padding: 40 }}>
              {objArr &&
                objArr.map(({ title, body, state }) => (
                  <AccordionItem key={title} title={title} body={body} state={state} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Accordion
